import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Layout from './components/layout/Layout';
import { EnquiryProvider } from './context/EnquiryContext';
import Home from './pages/Home';
import About from './pages/About';
import Collections from './pages/Collections';
import CollectionDetail from './pages/CollectionDetail';
import Reels from './pages/Reels';
import Contact from './pages/Contact';
import NotFound from './pages/NotFound';

export default function App() {
  return (
    <BrowserRouter>
      <EnquiryProvider>
        <Routes>
          <Route element={<Layout />}>
            <Route index element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/collections" element={<Collections />} />
            <Route path="/collections/:slug" element={<CollectionDetail />} />
            <Route path="/reels" element={<Reels />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
      </EnquiryProvider>
    </BrowserRouter>
  );
}
